import RiveComponent from "@rive-app/react-canvas";

type Props = {
  code: number;
};

function SalonTymLady({ code }: Props) {
  const isScooter = code === 1 || code === 2;

  return (
    <div style={{ width: 70, height: 70 }}>
      <RiveComponent
        src={isScooter ? "/animation/Salon_lady.riv" : "/animation/Scooter.riv"}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
}

export default SalonTymLady;
